import { useEffect, useState } from 'react'
import { ensureSession } from '../lib/session.js'

export function useItemizSession() {
  const [ready, setReady] = useState(false)
  const [error, setError] = useState(null)
  const [userId, setUserId] = useState(null)

  useEffect(() => {
    let cancelled = false
    ensureSession()
      .then((s) => {
        if (!cancelled) {
          setUserId(s.user_id)
          setReady(true)
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e.message)
          setReady(true)
        }
      })
    return () => { cancelled = true }
  }, [])

  return { ready, error, userId }
}
